export const SUBGRAPH_GNOSIS_ENDPOINT =
  'https://indexer.hyperindex.xyz/1a2f51c/v1/graphql'
